import React, { useState, useEffect, useCallback, useRef } from 'react';
import { GoogleMap, useJsApiLoader, Polygon, Polyline } from '@react-google-maps/api';
import blackcar from '../../assets/img/map_car_b.png';
import redcar from '../../assets/img/map_car_r.png';
import greencar from '../../assets/img/map_car_g.png';
import greycar from '../../assets/img/map_car_gr.png';
import * as turf from '@turf/turf';

const mapStyles = {
  width: '100%',
  height: '87vh',
};

const GoogleMapComponent = ({ dataToSend, geofenceCoordinates, teleStatus, selectedVehicle  }) => {
  const [blackCarCount, setBlackCarCount] = useState(0);
  const [redCarCount, setRedCarCount] = useState(0);
  const [greyCarCount, setGreyCarCount] = useState(0);
  const [greenCarCount, setGreenCarCount] = useState(0);
  const [path, setPath] = useState([]);
  const [allPolylines, setAllPolylines] = useState([])
  const [defaultCenter, setDefaultCenter] = useState({ lat: 51.081467, lng: -113.999875 });
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyC36o4niEA5vZG4bMS0CM5FBQaKEt6QADw',
  });
  const [map, setMap] = useState(null);
  const [infoWindow, setInfoWindow] = useState(null); // State for InfoWindow instance

  const polylineOptions = {
    strokeColor: 'orange', // Blue color
    strokeOpacity: 0.8,
    strokeWeight: 6,
  };

  const markerRef = useRef(null);
  const markersRef = useRef([]);
  
  const clearAllMarkers = () => {
    if (markerRef.current) {
      markerRef.current.setMap(null);
      markerRef.current = null;
    }
  
    if (markersRef.current.length > 0) {
      markersRef.current.forEach(marker => marker.setMap(null));
      markersRef.current = [];
    }
  };
  
  useEffect(() => {
    if (!map || !selectedVehicle || selectedVehicle.length === 0) return;

    if (dataToSend.vehicle !== 'one_vehicle') return;

  
    clearAllMarkers()
  
    const vehicle = selectedVehicle[0];
    const lat = vehicle.tele_data?.geolocation?.latitude;
    const lng = vehicle.tele_data?.geolocation?.longitude;
  
    if (lat && lng) {
      const newPosition = { lat, lng };
  
      const v_parking = isInsideGeofence([lat, lng]);
      const v_state = isInsideGeofenceState([lat, lng]); 
  
      let markerIcon;
      if (vehicle.current_status === 'In Maintenance') {
        markerIcon = {
          url: greycar,
          scaledSize: new window.google.maps.Size(30, 25),
        };
      } else if (!v_state) {
        markerIcon = {
          url: redcar,
          scaledSize: new window.google.maps.Size(30, 25),
        };
      } else if (vehicle.agreement_type === 'Off Agreement' && v_parking) {
        markerIcon = {
          url: blackcar,
          scaledSize: new window.google.maps.Size(30, 25),
        };
      } else if (vehicle.agreement_type === 'Off Agreement' && !v_parking) {
        markerIcon = {
          url: redcar,
          scaledSize: new window.google.maps.Size(30, 25),
        };
      } else {
        markerIcon = {
          url: greencar,
          scaledSize: new window.google.maps.Size(30, 25),
        };
      }
  
      // Add new marker
      markerRef.current = new window.google.maps.Marker({
        position: newPosition,
        map: map,
        icon: markerIcon,
        title: `VIN: ${vehicle.vin_number}`,
      });
  
      map.setCenter(newPosition);
      map.setZoom(18);
    }
  }, [selectedVehicle, map]);
  
  useEffect(() => {
    return () => {
      clearAllMarkers();
    };
  }, []);

  const onLoad = useCallback((mapInstance) => {
    let grey = 0;
    let green = 0;
    let black = 0;
    let red = 0;
    setMap(mapInstance);
    clearAllMarkers();
    const bounds = new window.google.maps.LatLngBounds();

    const customIcon = {
      url: greencar,
      scaledSize: new window.google.maps.Size(30, 25),
    };
    const customIcon2 = {
      url: redcar,
      scaledSize: new window.google.maps.Size(30, 25),
    };
    const customIcon3 = {
      url: blackcar,
      scaledSize: new window.google.maps.Size(30, 25),
    };
    const customIcon4 = {
      url: greycar,
      scaledSize: new window.google.maps.Size(30, 25),
    };

    if(dataToSend.vehicle == 'one_vehicle')
    {
      const vehicle = selectedVehicle[0];
      const vehicleLocation = {
        lat: vehicle.tele_data.geolocation.latitude,
        lng: vehicle.tele_data.geolocation.longitude,
      };
      mapInstance.setCenter(vehicleLocation);
      mapInstance.setZoom(18);
    }
    else
    {
      // Fit map to bounds
      mapInstance.fitBounds(bounds);
      setDefaultCenter(bounds.getCenter().toJSON());
    }

    // Add markers
    const markerData = dataToSend.vehicle !== 'one_vehicle' ? teleStatus : selectedVehicle;
    let customMarker;
    markerData.forEach((latlong, index) => {
      const v_parking = isInsideGeofence([latlong.tele_data.geolocation.latitude, latlong.tele_data.geolocation.longitude]); // true or false
      const v_state = isInsideGeofenceState([latlong.tele_data.geolocation.latitude, latlong.tele_data.geolocation.longitude]); // true or false
      bounds.extend(new window.google.maps.LatLng(latlong.tele_data.geolocation.latitude, latlong.tele_data.geolocation.longitude));
      if (v_state === false){
        customMarker = customIcon2;
        red = red+1;
      }else if(latlong.current_status === 'In Maintenance'){
        customMarker = customIcon4;
        grey = grey+1;
      }else if(latlong.agreement_type === 'Off Agreement' && v_parking === true){
        customMarker = customIcon3;
        black = black+1;
      }else if(latlong.agreement_type === 'Off Agreement' && v_parking === false){
        customMarker = customIcon2;
        red = red+1;
      }else{
        customMarker = customIcon;
        green = green+1;
      }
      const marker = new window.google.maps.Marker({
        position: { lat: latlong.tele_data.geolocation.latitude, lng: latlong.tele_data.geolocation.longitude },
        map: mapInstance,
        title: `VIN: ${latlong.vin_number}`,
        icon: customMarker,
      });
      markersRef.current.push(marker);
      marker.addListener('click', () => {
        const lastDateTime = latlong.tele_data.geolocation?.datetime || latlong.tele_data.datetime;
        const contentString = `
          <div>
            <p><b>VIN:</b> ${latlong.vin_number}</p>
            <p><b>Current Status:</b> ${latlong.current_status}</p>
            <p><b>Agreement Number:</b> ${latlong.agreement_number}</p>
            <p><b>Last DateTime:</b> ${lastDateTime}</p>
          </div>
        `;  
        // Open new infoWindow
        const newInfoWindow = new window.google.maps.InfoWindow({
          content: contentString,
        });
        newInfoWindow.open(mapInstance, marker);

        // Set selected marker and infoWindow to state
        setInfoWindow(newInfoWindow);
      });
    });
    setBlackCarCount(black);
    setGreenCarCount(green);
    setRedCarCount(red);
    setGreyCarCount(grey);
    const menuList = geofenceCoordinates.state.map(latlong => ({
      lat: latlong[0],
      lng: latlong[1]
    }));
    const menuList2 = geofenceCoordinates.parking.map(latlong => ({
      lat: latlong[0],
      lng: latlong[1]
    }));

    // const flattenTollData = (tollData) => {
    //   const flattenedPoints = [];
    //   tollData.forEach(tollPath => {
    //     tollPath.forEach(coordinatePair => {
    //       // Ensure the format is { lat, lng }
    //       const latLngObject = {
    //         lat: coordinatePair[0],
    //         lng: coordinatePair[1],
    //       };
    //       flattenedPoints.push(latLngObject);
    //     });
    //   });
    //   return flattenedPoints.slice(0, 500);
    // };
    // const snappedPoints = flattenTollData(geofenceCoordinates.tolls);
    // setPath(snappedPoints);

    // Function to flatten a single set of toll data
    const getPolylines = () => {
      return Object.keys(geofenceCoordinates.tolls).map(key => {
        const tollPath = geofenceCoordinates.tolls[key];
        return tollPath.map(coordinate => ({
          lat: coordinate[0],
          lng: coordinate[1],
        }));
      });
    };
  
    // Get all polylines from tolls
    const allPolylines = getPolylines();
    setAllPolylines(allPolylines)

    new window.google.maps.InfoWindow({
      content: "contentString",
      ariaLabel: "Uluru",
    });

   
    
    // Add polygon
    new window.google.maps.Polygon({
      paths: menuList,
      strokeColor: "#6C24D9",
      strokeOpacity: 1,
      fillColor: "#6C24D9",
      fillOpacity: 0.05,
      map: mapInstance,
    });
    new window.google.maps.Polygon({
      paths: menuList2,
      strokeColor: "#2448D9",
      strokeOpacity: 1,
      fillColor: "#2448D9",
      fillOpacity: 0.05,
      map: mapInstance,
    });

  }, [dataToSend, teleStatus, selectedVehicle, geofenceCoordinates]);

  const onCloseInfoWindow = () => {
    if (infoWindow) {
      infoWindow.close();
    }
  };

  if (loadError) {
    return <div>Error loading Google Maps</div>;
  }
  const isInsideGeofence = (position) => {
    if (geofenceCoordinates.parking && geofenceCoordinates.parking.length > 0) {
      // Ensure the polygon is closed by repeating the first coordinate at the end
      const closedGeofenceCoordinates = [...geofenceCoordinates.parking, geofenceCoordinates.parking[0]];
      
      const point = turf.point(position);
      const polygon = turf.polygon([closedGeofenceCoordinates]);
      return turf.booleanPointInPolygon(point, polygon);
    } else {
      return false; // Handle the case where geofenceCoordinates is not properly defined
    }
  };
  const isInsideGeofenceState = (position) => {
    if (geofenceCoordinates.state && geofenceCoordinates.state.length > 0) {
      // Ensure the polygon is closed by repeating the first coordinate at the end
      const closedGeofenceCoordinates = [...geofenceCoordinates.state, geofenceCoordinates.state[0]];
      
      const point = turf.point(position);
      const polygon = turf.polygon([closedGeofenceCoordinates]);
      return turf.booleanPointInPolygon(point, polygon);
    } else {
      return false; // Handle the case where geofenceCoordinates is not properly defined
    }
  };
  return isLoaded ? (
    <div>
      <GoogleMap
        mapContainerStyle={mapStyles}
        zoom={3}
        center={defaultCenter}
        onLoad={onLoad}
        onClick={onCloseInfoWindow}
      >
      {allPolylines.map((polyline, index) => (
          <Polyline
            key={index} // Use a unique key for each polyline
            path={polyline} // Path for this polyline
            options={{
              strokeColor: '#FFA500', // Set the color to orange
              strokeOpacity: 0.8,
              strokeWeight: 6,
            }}
          />
        ))}
      </GoogleMap>
      <div className='map_text'>
        <div className='row'>
          <div className='col-3 d-flex'>
            <span className='text-center'><img src={blackcar} className='map_text_img'/><br/><b>({blackCarCount})</b></span>
            <span><b>Off agreement</b> units <b>only inside </b>Parking Lot geofence</span>
          </div>
          <div className='col-3 d-flex'>
            <span className='text-center'><img src={greencar} className='map_text_img'/><br/><b>({greenCarCount})</b></span>
            <span><b>On agreement</b> units <b>inside</b> Parking Lot or Out of Area geofence</span>
          </div>
          <div className='col-4 d-flex'>
            <span className='text-center'><img src={redcar} className='map_text_img'/><br/><b>({redCarCount})</b></span>
            <span><b>Off agreement</b> units <b>outside</b> Parking Lot or <b>On agreement</b> units <b>outside</b> Out of Area geofence</span>
          </div>
          <div className='col-2 d-flex'>
            <span className='text-center'><img src={greycar} className='map_text_img'/><br/><b>({greyCarCount})</b></span>
            <span><b>In Maintenance</b></span>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div>Loading...</div>
  );
};

export default GoogleMapComponent;
